// ============================================
// TESTIMONIALS SECTION - Shrileela Beach Resort
// ============================================

const testimonials = [
  {
    id: 1,
    name: "Priya & Rohan Kulkarni",
    rating: 5,
    comment: "An absolute gem near Murud Beach! The Malvani food was outstanding and the staff was incredibly warm. Our couple room had a perfect sea view. Will definitely return!",
    date: "March 2025",
    location: "Pune",
    avatar: "🏖️"
  },
  {
    id: 2,
    name: "Vikram Desai",
    rating: 5,
    comment: "Perfect budget stay for a family trip. Clean rooms, amazing seafood, and literally 2 minutes walk to the beach. The bonfire evening was a highlight for the kids!",
    date: "February 2025",
    location: "Mumbai",
    avatar: "🌊"
  },
  {
    id: 3,
    name: "Aisha Shaikh",
    rating: 4,
    comment: "Very affordable for what you get. The beach access is incredible, the staff goes above and beyond. Fresh fish thali was the best I've had in the Konkan region!",
    date: "April 2025",
    location: "Nashik",
    avatar: "🌴"
  }
];

const TestimonialsSection = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,400;1,600;0,700&family=Jost:wght@300;400;500;600&display=swap');
        .testi-section {
          padding: 100px 24px;
          background: #fff;
          font-family: 'Jost', sans-serif;
        }
        .testi-inner { max-width: 1100px; margin: 0 auto; }
        .testi-header { text-align: center; margin-bottom: 64px; }
        .testi-eyebrow {
          display: inline-block; background: #fef3e0; color: #b8860b;
          font-size: 11px; font-weight: 700; letter-spacing: 3px; text-transform: uppercase;
          padding: 6px 18px; border-radius: 40px; margin-bottom: 20px;
        }
        .testi-title {
          font-family: 'Playfair Display', serif; font-size: clamp(32px, 5vw, 52px);
          font-weight: 700; color: #1a2b1a; margin: 0 0 16px;
        }
        .testi-subtitle { font-size: 17px; color: #666; font-weight: 300; }

        .testi-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-bottom: 48px; }
        .testi-card {
          background: #f8faf7; border-radius: 20px; padding: 32px;
          border: 1.5px solid #e8f0e8; transition: all 0.35s;
          position: relative;
        }
        .testi-card:hover { transform: translateY(-4px); box-shadow: 0 16px 50px rgba(61,90,62,0.1); border-color: #c8dcc8; }
        .testi-quote-mark {
          font-family: 'Playfair Display', serif;
          font-size: 80px; color: #c8dcc8; line-height: 0.6;
          position: absolute; top: 24px; right: 24px;
          font-style: italic;
        }
        .testi-stars { display: flex; gap: 3px; margin-bottom: 20px; }
        .testi-star { color: #f59e0b; font-size: 18px; }
        .testi-comment {
          font-size: 15px; color: #444; line-height: 1.8;
          margin-bottom: 24px; font-style: italic; font-weight: 300;
        }
        .testi-footer { display: flex; align-items: center; gap: 14px; border-top: 1px solid #e0eae0; padding-top: 20px; }
        .testi-avatar {
          width: 46px; height: 46px; border-radius: 50%;
          background: #3d5a3e; display: flex; align-items: center; justify-content: center;
          font-size: 20px; flex-shrink: 0;
        }
        .testi-name { font-weight: 600; color: #1a2b1a; font-size: 15px; }
        .testi-meta { font-size: 12px; color: #888; margin-top: 2px; }

        .testi-summary {
          text-align: center;
          padding: 36px;
          background: #f8faf7; border-radius: 20px;
          border: 1.5px solid #e0eae0;
        }
        .testi-rating-big {
          font-family: 'Playfair Display', serif;
          font-size: 56px; font-weight: 700; color: #3d5a3e; line-height: 1;
        }
        .testi-stars-row { display: flex; justify-content: center; gap: 4px; margin: 12px 0 8px; }
        .testi-count { color: #888; font-size: 14px; }

        @media (max-width: 900px) { .testi-grid { grid-template-columns: 1fr; } }
      `}</style>

      <section className="testi-section">
        <div className="testi-inner">
          <div className="testi-header">
            <span className="testi-eyebrow">Guest Reviews</span>
            <h2 className="testi-title">What Our Guests Say</h2>
            <p className="testi-subtitle">Real experiences from our valued guests</p>
          </div>

          <div className="testi-grid">
            {testimonials.map(t => (
              <div key={t.id} className="testi-card">
                <div className="testi-quote-mark">"</div>
                <div className="testi-stars">
                  {Array(t.rating).fill(0).map((_, i) => <span key={i} className="testi-star">★</span>)}
                </div>
                <p className="testi-comment">"{t.comment}"</p>
                <div className="testi-footer">
                  <div className="testi-avatar">{t.avatar}</div>
                  <div>
                    <div className="testi-name">{t.name}</div>
                    <div className="testi-meta">{t.location} · {t.date}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="testi-summary">
            <div className="testi-rating-big">4.8</div>
            <div className="testi-stars-row">
              {Array(5).fill(0).map((_, i) => <span key={i} style={{ color: '#f59e0b', fontSize: '24px' }}>★</span>)}
            </div>
            <div className="testi-count">Based on 250+ verified guest reviews</div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialsSection;